import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import {FullAnalysisFolderList} from "./FullAnalysisFolderList";
import {FullAnalysisFile} from "./FullAnalysisFile";
import folder1 from '../../../../assets/folder-a.svg';
import { FullAnalysisCrumbs } from "./FullAnalysisCrumbs";
import { FSPlanarize, FSResolve, IPlanarFolder, makeAnalysisForClient } from "./FSPlanarize";
import { FullAnalysisFolderSettings } from "./FullAnalysisFolderSettings";
import { IFileProvider } from "../../../../api/fileProvider/IFileProvider";
import { MockFileProvider } from "../../../../api/fileProvider/mockProvider";
import { ServerFileProvider } from "../../../../api/fileProvider/serverProvider";
import { MultiFileProvider } from "../../../../api/fileProvider/multiFileProvider";
import { FullAnalysisSelectFilePopup } from "./FullAnalysisSelectFilePopup";
import { ClientFileView} from "./ClientFileView";
import { IAnalysisFolder } from "./IAnalysisFolder";
import { GoodScroll } from "../../../desktopPage/GoodScroll";
import { AnimatedMenu } from "../../../desktopPage/AnimatedMenu";
import { GFileProvider } from "../../../../api/fileProvider/gFileProvider";
import { GViewer } from "../../../desktopPage/GViewer";
import { AnalysisProvider } from "../../../../api/fileProvider/analysisProvider";
import { DashboardContext } from "../../DashboardContext";
import { Spinner } from "../../../../components/spinner/Spinner";
import { AppContext } from "../../../../appContext";
import { FullAnalysisAddFolderPanel, FullAnalysisAddFolderPanelNew } from "./FullAnalysisAddFolderPanel";
import { IFullAnalysisFileRecord } from "./FullAnalysisTypes";
import './FullAnalysis.css';

const FullAnalysisSolarisFilesOld = ()=>{
    const solarisFiles = ['Geshtalt therapy', 'Cognitive behavioral therapy', 'Art therapy', 'Group therapy'];

    return <div className="FullAnalysis_files_block">
        <div className="FullAnalysis_breadcrumbs_head FullAnalysis_breadcrumbs_solaris">
            <div className="FullAnalysis_breadcrumbs">
                <div className="FullAnalysis_crumb">
                    Solaris files
                </div>
            </div>
        </div>
        <div className="FullAnalysis_files">
            {/*solarisFiles.map(folder=><FullAnalysisFolder folder={{name: folder, avatarUrl: folderIcon, date: ''}} onSelect={()=>{}}></FullAnalysisFolder>)*/}
        </div>
    </div>
}

//console.log(FSPlanarize(foldersRoot));
//console.log(FSResolve(FSPlanarize(foldersRoot)));

const filterFileForClient = (file: IPlanarFolder, clientId: string):IPlanarFolder=>{
    const folder = file;
    const result: IFullAnalysisFileRecord[] =[];
    if (folder.fileData && Array.isArray(folder.fileData)) {
        folder.fileData.forEach(record=>{
            if (record.relatedClientId == clientId){
                result.push(record);
            }
        });
    }
    return {
        ...file,
        fileData: result
    }
}

const createFilteredProvider = (clientId: string)=>{
    return class FilteredProvider extends AnalysisProvider{
        protected filterFolders(folders: IPlanarFolder[]): IPlanarFolder[] {
            if (!folders || !Array.isArray(folders)) {
                return [];
            }
            const filtered = folders.map(folder=>{
                if (folder.type == 'file' && folder.fileData){
                    return filterFileForClient(folder, clientId)
                }
                return folder;
            }).filter(folder=>{
                if (folder.type == 'file' && folder.fileData && Array.isArray(folder.fileData)){
                    if (folder.fileData.length == 0){
                        return false;
                    }
                    return true;
                }
                return true;
            });
            return filtered;
        }
    }
}

interface IFullAnalysisProps{
    onClose: ()=>void;
}

export const FullAnalysis = ({onClose}: IFullAnalysisProps)=>{
    const [fileProvider, setFileProvider] = useState<IFileProvider>(null);
    const [selectedForEdit, setSelectedForEdit] = useState<IAnalysisFolder>(null);
    const [selectedFileOpen, setSelectedFileOpen] = useState<boolean>(false);
    const fileSelectRef = useRef<HTMLInputElement>(null);
    const [selectedTabId, setSelectedTabId] = useState('client');
    const {selectedClient} = useContext(DashboardContext);
    const [savedCrumbs, setSavedCrumbs] = useState<Array<IAnalysisFolder>>();
    const [fix, setFix]=useState(0);
    const {cheat, translate} = useContext(AppContext);

    // Safety check for selectedClient
    if (!selectedClient) {
        return <div className="FullAnalysis">
            <div className="FullAnalysis_form">
                <div className="FullAnalysis_content">
                    <div>No client selected</div>
                </div>
            </div>
        </div>;
    }

    useEffect(()=>{
        console.log(currentMode);
        //let savedCrumbs: IAnalysisFolder[] = [];
        if (fileProvider){
            //savedCrumbs = fileProvider.crumbs;
            setSavedCrumbs(fileProvider.crumbs);
        }
        const provider = currentMode.providerFunc();
        setFileProvider(provider);
    }, [selectedClient, selectedTabId]);

    const crumbs: IAnalysisFolder[] = fileProvider?.crumbs;
    const currentFolder = crumbs?.[crumbs.length - 1];

    console.log(currentFolder);

    useEffect(()=>{
        console.log('change file provider ', fileProvider, selectedTabId);
        if (!fileProvider){
            return;
        }

        if (!savedCrumbs || savedCrumbs.length == 0){
            fileProvider.getFiles();
        } else {
            if (fileProvider instanceof MultiFileProvider){
                fileProvider.getFiles(savedCrumbs[savedCrumbs.length-1].id, savedCrumbs[savedCrumbs.length-1].name, savedCrumbs)
            }
        }

    }, [fileProvider]);

    const handleCrumb = (folder: IAnalysisFolder)=>{
        fileProvider.getFiles(folder.id, folder.name);
    }

    const handleAddFolder = ()=>{
        const newFolderData: IAnalysisFolder = {
            folderItems: [],
            name: 'newFolder' + currentFolder.folderItems.length,
            iconIndex: 0,
            date: new Date(),
            type: 'folder',
        };
        fileProvider.createFolder(newFolderData, currentFolder.id);
        setFix(last=>last+1);
    }

    const allFilesTab = <>
        {currentFolder?.type == 'folder' && (currentFolder.loadingStatus == 'error' ? 
        <div 
            onClick={()=>{
                fileProvider.connect().then(()=>fileProvider.getFiles(currentFolder.id))
            }}
        >
            reconnect
        </div> : <div>
            <FullAnalysisFolderList 
                folder={currentFolder} 
                onSelect={(folder)=>fileProvider.getFiles(folder.id)} 
                onRename={(item, newName)=>fileProvider.updateFile({...item, name: newName})}
                onDelete={(item, parent)=>{
                    fileProvider.deleteFile(item.id);
                }}
                onSettings={(item)=>{
                    console.log('selected for edit', item)
                    setSelectedForEdit(item);
                }}
            ></FullAnalysisFolderList> 

            <FullAnalysisAddFolderPanelNew 
                selectedItem={null} 
                provider={fileProvider}
            ></FullAnalysisAddFolderPanelNew>

            {/*<FullAnalysisAddFolderPanel
                onAdd={handleAddFolder}
            ></FullAnalysisAddFolderPanel>*/}

            {currentFolder?.fileData?.length > 0 && (
                <FullAnalysisFile file={{...currentFolder, type: 'file'}}></FullAnalysisFile>
            )}
        </div>)}

        {currentFolder?.type == 'file' && <FullAnalysisFile file={currentFolder}></FullAnalysisFile>}
    </>

    const allFilesCrumbs = (crumbs && crumbs.length >=1) ?
        <FullAnalysisCrumbs 
            crumbs={crumbs}
            onCrumb={handleCrumb}
        ></FullAnalysisCrumbs> : <Spinner></Spinner>

    const availableViewModes = [
        {
            name: 'oneList',
            title: 'One list',
            desc: 'Show all records for selected client as one analysis file',
            crumbs: <div className="FullAnalysis_feedTab_title"></div>,
            view: selectedClient ? <ClientFileView clientId={selectedClient.id}></ClientFileView> : <div>No client selected</div>,
            providerFunc: ()=>{
                return null as IFileProvider;
            }
        },
        {
            name: 'client',
            title: 'Client',
            desc: 'Show files contains selected client records, show only this client record in file',
            crumbs: allFilesCrumbs,
            view: allFilesTab,
            providerFunc: ()=>{
                if (!selectedClient || !selectedClient.id) {
                    return null;
                }
                const provider = new MultiFileProvider(createFilteredProvider(selectedClient.id));
                provider.onChange = ()=>{
                    setFix(last=>last+1);
                }
                provider.onAuthError = ()=>{

                }
                return provider;
            }
        },
        {
            name: 'all',
            title: translate('full_analysis_all_files'),
            desc: translate('full_analysis_all_files_desc'),
            crumbs: allFilesCrumbs,
            view: allFilesTab,
            providerFunc: ()=>{
                const provider = new MultiFileProvider(AnalysisProvider);
                provider.onChange = ()=>{
                    setFix(last=>last+1);
                }
                provider.onAuthError = ()=>{

                }
                return provider;
            }
        }
    ];
    const shownModes = cheat.debug ? availableViewModes : availableViewModes.filter(it=>['client', 'all'].includes(it.name));

    const currentMode = availableViewModes.find(it=>it.name == selectedTabId);

    return (
        <div className="FullAnalysis">
            <GoodScroll>
            <div className="FullAnalysis_form">

                <div className="FullAnalysis_header" style={{display: 'none'}}>
                    <div className="FullAnalysis_title">
                        {translate('bottomMenu_Analysis')}
                    </div>
                    <div className="addSession_icon addSession_close_icon" onClick={onClose}></div>
                </div>

                <div className="FullAnalysis_content">            
                    <div className="FullAnalysis_breadcrumbs_head">
                        {currentMode.crumbs}

                        <div className="FullAnalysis_tabButtons">
                            <AnimatedMenu 
                                items={shownModes.map(it=>translate(it.title as any))}
                                selectedIndex={shownModes.findIndex(it=>it.name == selectedTabId)}
                                onSelect={(index)=>{
                                    setSelectedTabId(shownModes[index].name)
                                }}
                            ></AnimatedMenu>
                        </div>
                    </div>
                    {currentMode.view}
                    {cheat.debug && <FullAnalysisSolarisFilesOld></FullAnalysisSolarisFilesOld>}                    
                </div>
            </div>
            </GoodScroll>
            {selectedForEdit && <FullAnalysisFolderSettings
                folder={selectedForEdit}
                onClose={()=>{
                    setSelectedForEdit(null);
                }}
                onSubmit={(data)=>{
                    fileProvider.updateFile({...selectedForEdit, ...data});
                    setSelectedForEdit(null);
                }}
            ></FullAnalysisFolderSettings>}

            {selectedFileOpen && <FullAnalysisSelectFilePopup
                FileViewer={GViewer}
                onClose={()=>{
                    setSelectedFileOpen(false);
                }}
                onSubmit={(item)=>{
                    setSelectedFileOpen(false);
                    if (fileProvider.providerName == 'g'){
                        fileProvider.createFolder({
                            name: item.name,
                            date: new Date(),
                            type: item.type == 'file' ? 'fileLink' : 'folderLink',
                            link: item.id,
                            linkProvider: 'g',
                            iconIndex: item.iconIndex || 0
                        }, currentFolder.id);
                    }
                }}
            >
            </FullAnalysisSelectFilePopup>}

            <input type="file" ref={fileSelectRef} style={{display: 'none'}} onChange={()=>{

            }}></input>
        </div>
    )
}